import styled from "@emotion/native";

export const Container = styled.View({
	marginBottom: 10,
});
export const Body = styled.TouchableOpacity({
	flexDirection: "row",
	// justifyContent: "space-between",
	justifyContent: "flex-start",
	alignItems: "center",
	marginVertical: 15,
	marginHorizontal: 25,
});

export const ArrowContainer = styled.View({
	height: 40,
	width: 40,
	marginLeft: 10,
	justifyContent: "center",
	alignItems: "center",
});

export const Thumbnail = styled.Image({
	height: 75,
	width: 100,
	marginRight: 20,
	resizeMode: "cover",
});
